import Checkout from '@wwdev/webshop/checkout';
import Events from "@wwdev/bootstrap/Events";

Checkout._toggleShipmentAddress = function(e) {
	if (e.currentTarget.value == 'nee') {
		jQuery('select[name="country"]').trigger('change');
		jQuery('#deliver_address').find('input, select').attr('disabled', 'disabled');
	} else {
		jQuery('#deliver_address').find('input, select').removeAttr('disabled');
	}
	this._checkShipmentNeedsRecalc(e.currentTarget.checked);
};

Checkout._addEventListeners = function() {
	var onCountryChange = (event, msg) => msg.value = $(msg.element).find(':selected').text();
	var onZipCodeChange = (event, msg) => msg.value = $(msg.element).val();
	this.toggleFields();
	Events.on('ww-bind.change.country', onCountryChange);
	Events.on('ww-bind.change.zipcode', onZipCodeChange);
	Events.on('ww-bind.change.shipping_country', onCountryChange);
	Events.on('ww-bind.change.shipping_zipcode', onZipCodeChange);

	this.$checkout.find('[name$="zipcode"]').change(this._countryOptionChange.bind(this));

	this.$checkout.find('[name="send_other_address"]').change(this._toggleShipmentAddress.bind(this))
		.change();
	this.$checkout.find('[name="create-account"]').change(this._toggleCreateAccount.bind(this));
	this.$checkout.find('[name$="country"]').change(this._countryOptionChange.bind(this));

	this.$checkout.on('change', '[data-action="select_shipping"]', this._shipmentOptionChange.bind(this));
	this.$checkout.find('[data-checkout-payment="scope"]').on('change', '[data-action="select_payment"]', this._paymentOptionChange.bind(this))
		.filter(':checked').change();

	// always new window
	this.$checkout.find('label[for=requirements] a').attr('target', '_blank');
	this.$checkout.on('click', '[data-toggle-fields]', this.toggleFieldListener.bind(this));

	this.$checkout.on('click', 'button[name="action"][value="save_concept"]', function() {
		jQuery('input#requirements').removeAttr('required');
		jQuery('input[name="shipping-options"]').removeAttr('required');
	})
	this.$checkout.on('click', 'button[name="action"][value="store_order"]', function() {
		jQuery('input#requirements').attr('required', 'required');
		jQuery('input[name="shipping-options"]').attr('required', 'required');
	})
};



Checkout.toggleFieldListener = function(e) {
	let target = '[data-toggle-fields=' + $(e.currentTarget).data('toggle-fields') + ']';
	let $target = this.$checkout.find(target + ':checked');

	this.toggleField($target);
};

Checkout.toggleField = function($target) {
	let $collapsable = $($target.data('target'));

	if($target.data('toggle-open') == 1) {
		$collapsable.slideDown();
	} else {
		$collapsable.slideUp();
	}
};

Checkout.toggleFields = function() {
	this.$checkout.find('[data-toggle-fields]').each((it, el) => {
		let target = '[data-toggle-fields=' + $(el).data('toggle-fields') + ']';
		let $target = this.$checkout.find(target + ':checked');

		this.toggleField($target);
	})
};

export default Checkout;